import { render, staticRenderFns } from "./DetailsDialog.vue?vue&type=template&id=1cfc0485"
import script from "./DetailsDialog.vue?vue&type=script&lang=js"
export * from "./DetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports